module.exports = __webpack_public_path__ + "img/20200425145525965.425340ba.png";